import script from "./SaveSearchModal.vue?vue&type=script&setup=true&lang=js"
export * from "./SaveSearchModal.vue?vue&type=script&setup=true&lang=js"

import "./SaveSearchModal.vue?vue&type=style&index=0&id=2c3319b3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c3319b3"]])

export default __exports__